module.exports = __webpack_public_path__ + "static/media/gnt.43e33c9a.svg";